import { render, staticRenderFns } from "./FollowUs.vue?vue&type=template&id=59eb9c1e&scoped=true"
import script from "./FollowUs.vue?vue&type=script&lang=js"
export * from "./FollowUs.vue?vue&type=script&lang=js"
import style0 from "./FollowUs.vue?vue&type=style&index=0&id=59eb9c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eb9c1e",
  null
  
)

export default component.exports